import { Typography, Card, Button, Stack } from '@mui/material';
import React, { Component } from 'react';
import { postData, getData, deleteData } from '../../../../../DataAccessLayer';
import { teamsDrive } from '../../../../../DataAccessLayer/services';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from '../../../../common/Loader';
import { getCourseMetadata } from '../utils';
import { FormButton } from '../../../../common/Form/FormButton';
import PortalModal from '../../../../common/PortalModal';
import { Container, Row, Col } from 'reactstrap';
import { WithSmallScreen } from '../../../../common/WithSmallScreen';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPeopleGroup, faChalkboardUser } from '@fortawesome/pro-light-svg-icons';

class Teams extends Component {
  state = {
    isModalOpen: false,
    type: null,
    teamsDrive: {},
    isLoading: false,
    isOpenSharedDrive: false,
    isDeleteModalOpen: false,
  };

  // type maps to Microsoft Graph API team template types: 'groups' (Basic Team) or 'classes' (Class Team)
  selectTeamsType = (type) => {
    this.setState({ type });
  };

  componentDidMount() {
    this.getTeamsDrive();
  }

  handleToggleModal = (modal) => {
    this.setState({ [modal]: !this.state[modal] });
  };

  getTeamsDrive = async () => {
    const { encodedName, crn, termCode } = getCourseMetadata(this.props.course);

    this.setState({ isLoading: true });

    try {
      const data = await getData(teamsDrive.get({ name: encodedName, crn, termCode }), true);

      this.setState({ teamsDrive: data });
    } catch (err) {
      console.log(err);
      this.setState({ teamsDrive: {} });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  createTeamsDrive = async (type) => {
    const { name, crn, termCode } = getCourseMetadata(this.props.course);

    const body = {
      name,
      crn,
      termCode,
    };

    try {
      this.setState({ isLoading: true });
      await postData(teamsDrive.create(type), body, true);
      toast.success('Microsoft Teams site created!');
    } catch (err) {
      if (err.timeout) {
        toast.error('Microsoft Teams site creation pending. Please check back in 15 minutes.');
      } else {
        toast.error('Could not create Microsoft Teams site.');
      }
    } finally {
      this.setState({ isLoading: false });
      this.getTeamsDrive();
      this.setState({ isOpenSharedDrive: false });
    }
  };

  deleteTeamsDrive = async () => {
    const { encodedName, crn, termCode } = getCourseMetadata(this.props.course);

    try {
      this.setState({ isLoading: true });
      await deleteData(teamsDrive.delete({ name: encodedName, crn, termCode }), {}, true);
      toast.success('Microsoft Teams site deleted.');
    } catch (err) {
      toast.error('Could not delete Microsoft Teams site.');
    } finally {
      this.setState({ isLoading: false });
      this.getTeamsDrive();
      this.setState({ isOpenSharedDrive: false });
      this.handleToggleModal('isDeleteModalOpen');
    }
  };

  render() {
    const { isDeleteModalOpen, type, teamsDrive, isLoading, isOpenSharedDrive } = this.state;

    const { course } = this.props;

    const isTeaching = course.isTeaching;

    return (
      <React.Fragment>
        <Container className="p-3">
          <Loader isOpen={isLoading} />
          <Typography variant="h3">Microsoft Teams</Typography>

          <Row
            className={`justify-content-center align-items-center ${
              !teamsDrive.weburl ? 'flex-column' : 'flex-row'
            }`}
          >
            {!isOpenSharedDrive && (
              <Col
                xs="12"
                sm="6"
                md="6"
                lg="3"
                className={`d-flex ${
                  !teamsDrive.weburl ? 'justify-content-center' : 'justify-content-end'
                } align-items-center`}
                style={{ width: 200 }}
              >
                <img
                  src={!teamsDrive.weburl ? '/img/cct_teamsSearch.svg' : '/img/cct_teams.svg'}
                  alt="" //decorative
                  style={{ width: '100%', height: 'auto' }}
                />
              </Col>
            )}

            {!teamsDrive.weburl ? (
              !isOpenSharedDrive && (
                <Row className="w-100">
                  <Col className="text-center p-2">
                    <Typography component="p" sx={{ my: 1 }}>
                      There is no Microsoft Teams site for this class.
                    </Typography>
                    {isTeaching && (
                      <Button
                        onClick={() =>
                          this.setState({
                            isOpenSharedDrive: true,
                          })
                        }
                        variant="outlined"
                      >
                        Create a Microsoft Team
                      </Button>
                    )}
                  </Col>
                </Row>
              )
            ) : (
              <Col xs="12" lg="3" className="d-flex flex-column align-items-center">
                <FormButton
                  label="Launch Microsoft Teams"
                  href={teamsDrive.weburl}
                  target="_blank"
                  disabled={!teamsDrive.weburl}
                  sx={{ mt: 2 }}
                />
                {isTeaching && (
                  <Button
                    sx={{ my: 1 }}
                    onClick={() => this.handleToggleModal('isDeleteModalOpen')}
                    variant="outlined"
                  >
                    Delete Microsoft Teams
                  </Button>
                )}
              </Col>
            )}

            {isOpenSharedDrive && (
              <Row className="w-100 flex-column">
                <Col style={{ padding: 0 }}>
                  <Card
                    className={`myOdu__selectionCard ${type === 'groups' ? 'selected' : ''}`}
                    elevation={0}
                    sx={{ margin: 1 }}
                    onClick={() => this.selectTeamsType('groups')}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.selectTeamsType('groups');
                      }
                    }}
                    role="button"
                    aria-pressed={type === 'groups'}
                    aria-selected={type === 'groups'}
                    tabIndex={0}
                  >
                    <Stack direction="row" alignItems="flex-start" spacing={2}>
                      <div className="icon">
                        <FontAwesomeIcon icon={faPeopleGroup} size="xl" />
                      </div>
                      <Stack>
                        <Typography component="h4">Basic Team</Typography>
                        <Typography variant="p" align="left">
                          Offers tools like chat, video calls, file sharing, channels for organizing
                          discussions, and integration with Microsoft Office apps.
                        </Typography>
                      </Stack>
                    </Stack>
                  </Card>
                </Col>
                <Col style={{ padding: 0 }}>
                  <Card
                    className={`myOdu__selectionCard ${type === 'classes' ? 'selected' : ''}`}
                    elevation={0}
                    sx={{ margin: 1 }}
                    onClick={() => this.selectTeamsType('classes')}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.selectTeamsType('classes');
                      }
                    }}
                    role="button"
                    aria-pressed={type === 'classes'}
                    aria-selected={type === 'classes'}
                    tabIndex={0}
                  >
                    <Stack direction="row" alignItems="flex-start" spacing={2}>
                      <div className="icon">
                        <FontAwesomeIcon icon={faChalkboardUser} size="xl" />
                      </div>
                      <Stack>
                        <Typography component="h4">Class Team</Typography>
                        <Typography variant="p" align="left">
                          Includes features specific to education, such as class notebook
                          integration, collaboration spaces for group projects, and attendance
                          tracking.
                        </Typography>
                      </Stack>
                    </Stack>
                  </Card>
                </Col>
              </Row>
            )}
          </Row>

          {isOpenSharedDrive && (
            <Row className="p-2">
              <Col
                xs="12"
                sm="6"
                className="d-flex justify-content-center justify-content-sm-start p-1"
              >
                <FormButton
                  className="myOdu__button sharedDriveButton"
                  label="Back"
                  onClick={() =>
                    this.setState({
                      isOpenSharedDrive: false,
                    })
                  }
                />
              </Col>
              <Col
                xs="12"
                sm="6"
                className="d-flex justify-content-center justify-content-sm-end p-1"
              >
                <FormButton
                  className="myOdu__button sharedDriveButton"
                  label="Create Teams Site"
                  disabled={teamsDrive.weburl || !type}
                  onClick={() => this.createTeamsDrive(type)}
                />
              </Col>
            </Row>
          )}
        </Container>
        <PortalModal
          severity="error"
          maxWidth="sm"
          onClose={() => this.handleToggleModal('isDeleteModalOpen')}
          onPrimaryClick={this.deleteTeamsDrive}
          onSecondaryClick={() => this.handleToggleModal('isDeleteModalOpen')}
          isOpen={isDeleteModalOpen}
          title="Delete Microsoft Teams"
          primaryButtonTitle="Yes"
          secondaryButtonTitle="No, Cancel"
        >
          <Loader isOpen={isLoading} />
          <Typography>Are you sure you want to delete this Team?</Typography>
        </PortalModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    course: state.CCTReducer.course,
  };
};

export default connect(mapStateToProps)(WithSmallScreen(Teams));
